import dynamic from 'next/dynamic';
import React from 'react';
import { PLATFORM } from '../../constants/platforms';
import { withPlatForm } from '../../utils/matcher/matcher';
const MwebWrapper = dynamic(() => import('../MwebWrapper/MwebWrapper'));

const MovieCityLanding = dynamic(() => import('./MovieCityLanding'));
const MovieCityLandingDesktop = dynamic(() => import('./MovieCityLandingDesktop'));

interface Props {
	cityName: string;
	cityLabel: string;
	type: string;
}

const MovieCityLandingHOC = (props: Props) => {
	return (
		<>
			{withPlatForm([
				{
					platform: [PLATFORM.D_WEB],
					component: <MovieCityLandingDesktop {...props} />,
				},
				{
					platform: [PLATFORM.M_WEB],
					component: (
						<MwebWrapper>
							<MovieCityLanding {...props} />
						</MwebWrapper>
					),
				},
			])}
		</>
	);
};

export default MovieCityLandingHOC;
